<template>
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.993 9.7798C15.55 9.88992 15.0985 10.0021 14.6229 10.0579C11.6513 10.4071 9.12036 8.33267 9.12036 5.39773C9.12036 4.90263 9.53588 4.88864 9.70243 5.25111C10.0721 6.05269 10.6243 6.80491 11.2358 7.26439C12.5525 8.25482 13.9851 8.11803 15.4641 7.68507C18.9904 6.65363 21.9899 8.64554 22.0297 12.0996C22.0342 12.4226 21.5776 12.5321 21.4317 12.2404C20.8967 11.1826 20.1921 10.2052 19.0422 9.73838C17.9482 9.29381 16.992 9.53147 15.993 9.7798ZM2.5 13.6883V19H22.5V13.6883H2.5ZM20.9614 17.4823H10.9614V15.2058H20.9614V17.4823Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "SmokingIcon",
});
</script>
